import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { ModalContainer, ModalContent, ModalHeader, ModalText, ModalTitle } from '../Modal';
import LoaderSpin from './LoaderSpin';

const Layout = styled.section`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: ${toRem(400)};
  margin: auto;
  height: auto;
  padding: 0 ${toRem(theme.space.xl)};
  border-radius: ${toRem(22)};
  background-color: ${theme.color.white};
  box-shadow: ${theme.shadow.modal};

  @media (min-width: ${theme.breakpoint.med}px) {
    height: ${toRem(380)};
    padding: 0 ${toRem(theme.space['3xl'])};
  }
`;

const StyledModalHeader = styled(ModalHeader)`
  padding-bottom: ${toRem(theme.space.lg)};
`;

const StyledModalContent = styled(ModalContent)`
  flex-grow: 0;
  padding-bottom: ${toRem(theme.space['3xl'])};
`;

const StyledLoaderSpin = styled(LoaderSpin).attrs({
  size: 55,
  stroke: 5.5,
  color: theme.color.secondary[300],
})`
  margin-top: ${toRem(theme.space.md)};
  margin-bottom: ${toRem(theme.space.xl)};
`;

interface LoaderModalProps {
  isActive?: boolean;
  title?: string;
  message?: string;
}

const LoaderModal: React.FC<LoaderModalProps> = ({ isActive, title = 'Loading', message = 'One moment please...' }) => (
  <ModalContainer isActive={isActive} closeOnOutSideClick={false}>
    <Layout>
      <StyledModalHeader>
        <StyledLoaderSpin />
        <ModalTitle>{title}</ModalTitle>
      </StyledModalHeader>

      <StyledModalContent>
        <ModalText>{message}</ModalText>
      </StyledModalContent>
    </Layout>
  </ModalContainer>
);

export default LoaderModal;
